import {FC} from 'react';
import {observer} from 'mobx-react';
import {Message, Popup} from 'semantic-ui-react';
import {map} from 'lodash';

import {Dashboard, PredefinedDashboard} from '../types';

import './DashboardPreview.less';

type DashboardPreviewProps = {
  dashboard: Dashboard | PredefinedDashboard;
}

const DashboardPreview: FC<DashboardPreviewProps> = observer(({dashboard}) => {
  if ('autoscaling' in dashboard && (dashboard.autoscaling || dashboard.dynamic)) {
    return (
      <Message
        info
        content='This dashboard has dynamic widgets. Preview is not available.'
      />
    );
  }
  return (
    <div className='iba-dashboard-preview'>
      {map(dashboard.grid, (column, columnIndex) =>
        <div key={columnIndex} className='iba-dashboard-preview-column'>
          {map(column, (widget, widgetIndex) => {
            return (
              <Popup
                key={widgetIndex}
                trigger={
                  <div className='iba-widget-preview'>
                    <div>
                      <div className='widget-label'>
                        {widget.label}
                      </div>
                    </div>
                  </div>
                }
                size='small'
                content={widget.label}
                position='top center'
              />
            );
          })}
        </div>
      )}
    </div>
  );
});

export default DashboardPreview;
